const SummaryTableSchema = [
    {
        objectName: 'selectedCreditNoteLine',
        isLoading: 'loadingselectedCreditNoteLine',
        children: [
            {
                label: 'Product',
                fieldNames: [
                    'ProductIdDisplay',
                    'Description',
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/inventoryEnquiry/lookup/action',
                        name: 'enquiry',
                        params: {
                            queryFields: {
                                ProductId: 'ProductId'
                            }
                        }
                    }
                }
            },
            {
                label: 'Product Group',
                fieldNames: [
                    'ProductGroup'
                ]
            },
        ]
    },
    {
        objectName: 'selectedCreditNoteLine',
        isLoading: 'loadingselectedCreditNoteLine',
        children: [
            {
                label: 'Cost',
                fieldNames: [
                    'CostDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 4
                }
            },
            {
                label: 'Base',
                fieldNames: [
                    'BasePriceDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'GP',
                fieldNames: [
                    'GrossPercentageDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Sell/Unit',
                fieldNames: [
                    'SellPerUnitIncTaxDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Sell/Unit (EX. TAX)',
                fieldNames: [
                    'SellPerUnitExTaxDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
        ]
    },
    {
        objectName: 'selectedCreditNoteLine',
        isLoading: 'loadingselectedCreditNoteLine',
        children: [
            {
                label: 'Tax Total',
                fieldNames: [
                    'TaxTotalDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Extended Total',
                fieldNames: [
                    'ExtendedTotalDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    emphasize: true,
                    floatingPoints: 2
                }
            },
        ]
    }
];

export default SummaryTableSchema;
